<template>
    <div v-if="accessLogin === true" class="container my-3" style="max-height: 720px;" id="login">
        <div class="row" style="max-height: 720px;">
            <div class="col-12 p-0 text-center" style="max-height: 720px;">
                <img src="../../assets/security.svg" alt="" style="height:45%;" />
                <h5 class="font-weight-light mb-3">You shall not pass, please verify your identity</h5>
                <div class="row">
                <div class="col-md-6 mx-auto">
                    <form @submit.prevent="doLogin">
                    <div class="form-group">
                        <input type="email" class="form-control" v-model='email_login' placeholder="Enter your email" />
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" v-model='password_login' placeholder="Enter your password" />
                    </div>
                    <button type="submit" class="btn btn-primary btn-block">Login</button>
                    <button type="button" @click.prevent="doRegister" class="btn btn-primary btn-block">Register</button>
                    
                    <p style="margin: 8px">Login with Google Account: </p>
                    <button type="button" @click="onSignIn" class="btn btn-primary btn-block">Google Login</button>
                    </form>
                </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else-if="accessRegister === true" class="container my-3" style="max-height: 720px;" id="login">
        <div class="row" style="max-height: 720px;">
            <div class="col-12 p-0 text-center" style="max-height: 720px;">
                <img src="../../assets/register.png" alt="" style="height:45%;" />
                <h5 class="font-weight-light mb-3">Please input your identity</h5>
                <div class="row">
                <div class="col-md-6 mx-auto">
                    <form @submit.prevent="createUser">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model='name_register' placeholder="Enter your name" />
                    </div>

                    <div class="form-group">
                        <input type="email" class="form-control" v-model='email_register' placeholder="Enter your email" />
                    </div>

                    <div class="form-group">
                        <input type="password" class="form-control" v-model='password_register'  placeholder="Enter your password" />
                    </div>

                    <button type="submit" class="btn btn-primary btn-block">Register</button>
                    <button type="button" @click.prevent="closeRegister" class="btn btn-danger btn-block">Cancel</button>
                    </form>
                </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import axios from "axios"
import swal from 'sweetalert'

export default {
    name: "LoginForm",
    data() {
        return {
            email_login: "",
            password_login: "",
            accessRegister: false,
            name_register: "",
            email_register: "",
            password_register: "",
            url: 'https://gentle-gorge-36916.herokuapp.com'
        }
    },
    props: {
        accessLogin : Boolean
    },
    methods: {
        doLogin() {
            axios({
                url: `${this.url}/user/login`,
                method: 'post',
                data: {
                    email: this.email_login,
                    password: this.password_login
                }
            })
            .then(response => {
                this.resetForm()
                localStorage.setItem("token",response.data.token)
                localStorage.setItem("idUser",response.data.idUser)
                this.$emit('changeStatus')
                this.$emit('byDB')
            })
            .catch(err => {
                swal("Error!",err.response.data.message,"error")
                console.log(err)
            })
        },
        doRegister() {
            this.accessRegister = true
            this.$emit("switch")
        },
        resetForm () {
            this.email_login = ""
            this.password_login = ""
        },
        createUser(){
            axios({
                url: `${this.url}/user/register`,
                method: 'post',
                data: {
                    name: this.name_register,
                    email: this.email_register,
                    password: this.password_register
                }
            })
            .then(response => {
                this.resetFormRegister()
                this.closeRegister()
                console.log(response.data.user)
            })
            .catch(err => {
                swal("Error!",err.response.data.message,"error")
                console.log(err)
            })
        },
        resetFormRegister () {
            this.name_register = ""
            this.email_register = ""
            this.password_register = ""
        },
        closeRegister() {
            this.accessRegister = false,
            this.$emit("switch")
        },
        onSignIn() {
            this.$gAuth.signIn()
            .then(GoogleUser => {
            
                console.log('user', GoogleUser)
                let id_token = GoogleUser.getAuthResponse().id_token
                
                axios({
                    url: `${this.url}/user/google`,
                    method: 'POST',
                    data: { id_token }
                })
                .then(response => {
                    localStorage.setItem('token', response.data.token)
                    localStorage.setItem('idUser', response.data.idUser)
                    this.$emit('changeStatus')
                    this.$emit('byGoogle')
                })
                .catch(function (result) {
                    console.log(result)
                })
            })
            .catch(error => {
                console.log(error)
            })
        }
    }
}
</script>